import { render, staticRenderFns } from "./MultiSelectBox.vue?vue&type=template&id=6c2ad3da&scoped=true&"
import script from "./MultiSelectBox.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectBox.vue?vue&type=style&index=0&id=6c2ad3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ad3da",
  null
  
)

export default component.exports